import * as React from 'react';
import { Box, Typography, IconButton, Stack, Divider, TextField } from '@mui/material';
import { FaSquareMinus } from "react-icons/fa6";
import { FaSquarePlus } from "react-icons/fa6";
import { RiDeleteBin5Fill } from "react-icons/ri";


function ProductReqCard({ i, onQuantityChange, onRemove, index }) {
  return (
    <Box width={"100%"} position={"relative"}>
      <Stack direction={"row"} alignItems={"center"}>
        <Stack gap={1} width={"70%"}>
          <Typography sx={{ fontSize: 13, fontWeight: 600 }} >{i?.prodName}</Typography>
          <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} width={"100%"}>
            <Typography fontSize={11} fontWeight={600} width={"33.3%"}>
              <Box component="span" color={"rgb(0,0,0,0.6)"}>AMTC Ref ID</Box> - {i?.amtcProdIdStrg}
            </Typography>
            <Typography variant="body1" fontSize={11} fontWeight={600} width={"33.3%"}>
              <Box component="span" fontWeight="500" color={"rgb(0,0,0,0.4)"}>MATERIAL CODE</Box> - {i?.comProdIdStrg}
            </Typography>
            <Typography variant="body1" sx={{ my: 'auto' }} fontSize={11} fontWeight={600} width={"33.3%"}>
              <Box component="span" fontWeight="500" color={"rgb(0,0,0,0.4)"} >Price Agreement ID</Box> - {i?.priceAgreeId}
            </Typography>
          </Stack>
        </Stack>
        <Divider orientation="vertical" flexItem sx={{ mr: 2 }} />
        <Stack gap={1} height={"100%"} justifyContent={"center"} mt={1.4}>
          <Stack direction={"row"} alignItems={"center"} mb={-1.4}>
            <Typography sx={{ fontSize: 11, fontWeight: 600, width: 100, color: "rgb(0,0,0,0.4)" }}> Agreed Quantity </Typography>
            <Typography sx={{ fontSize: 11, fontWeight: 600, color: "rgb(0,0,0,0.4)" }}>: </Typography>
            <Typography sx={{ fontSize: 11, fontWeight: 600, ml: 1 }}> {i?.agreedQty} Nos </Typography>
          </Stack>

          <Stack direction={"row"} alignItems={"center"}>
            <Typography sx={{ fontSize: 11, fontWeight: 600, width: 100, color: "rgb(0,0,0,0.4)" }}> Added Quantity </Typography>
            <Typography sx={{ fontSize: 11, fontWeight: 600, color: "rgb(0,0,0,0.4)" }}>: </Typography>
            <Stack direction={"row"} alignItems={"center"} >
              <IconButton color='primary' onClick={async () => await onQuantityChange(index, -1)}>
                <FaSquareMinus />
              </IconButton>
              <TextField variant="outlined" fullWidth size="small" type='number' value={i?.qty}
                onChange={async (e) => { }} InputProps={{
                  inputProps: {
                    style: {
                      appearance: "textfield" // For some browsers
                    }
                  }
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    height: 22, width: 60, borderRadius: 1, fontSize: 13, color: "rgba(0, 0, 0, 1)",
                    backgroundColor: 'rgba(0, 0, 0, 0.1)',
                  },
                  '& input[type=number]': {
                    MozAppearance: 'textfield', // Firefox
                    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                      display: 'none', // Chrome, Safari, Edge
                    },
                  }
                }} />
              <IconButton color='primary' onClick={async () => await onQuantityChange(index, 1)}>
                <FaSquarePlus />
              </IconButton>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      <Box sx={{ position: "absolute", top: 2, right: 5 }}>
        <IconButton color='error' onClick={() => onRemove(index)}>
          <RiDeleteBin5Fill />
        </IconButton>
      </Box>
    </Box>
  );
}

export default ProductReqCard;